import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const COMPLETE_ADVISOR_SESSION = gql`
  mutation CompleteAdvisorSession($input: CompleteAdvisorSessionInput!) {
    completeAdvisorSession(input: $input) {
      advisorSession {
        ...AdvisorSessionFragment
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
